import React from 'react'
import styled from 'styled-components'
import { observer } from 'mobx-react-lite'
import TabSectionLabour from './1-TabSectionLabour'
import TabSectionMaterial from './2-TabSectionMaterial'
import TabSectionTransport from './3-TabSectionTransport'
import TabSectionMobileAssets from './4-TabSectionMobileAssets'
import _get from 'lodash/get'
import { useDRS } from '@src/modules/DRS/useDRS'
import { DRS } from '@src/types/drs/DRS'
import { ProjectTypeId } from '@src/types/ProjectTypeId'
import TabSectionSubcontractor from './5-TabSectionSubcontractor'

const AsphaltTab = () => {
  const { drs } = useDRS()
  if (drs === null) {
    return null
  }
  return <Wrapper>

    <TabSectionLabour
      isLast={false}
    />

    <TabSectionMaterial
      type='ASPHALT'
      isLast={false}
      data={getMaterialAsProducts(drs)}
      />

    <TabSectionTransport
      type='ASPHALT'
      isLast={false}
      data={drs}
    />

    <TabSectionMobileAssets
      type='ASPHALT'
      isLast={false}
      data={drs}
    />

    <TabSectionSubcontractor drs={drs} projectTypeId={ProjectTypeId.Asphalt} />

  </Wrapper>
}
const Wrapper = styled.div``
const getMaterialAsProducts = (drs: DRS) => {
  // drs.material.asphalt.detail
  return _get(drs, 'material.asphalt.detail')
}

export default observer(AsphaltTab)